<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "printCardOrders.shippingLabels.dialogTitle" | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body ups-labels-dialog__content">
    <p class="ups-labels-dialog__intro">
      {{ "printCardOrders.shippingLabels.dialogIntro" | translate }}
    </p>

    <div class="ups-labels-dialog__grid">
      <article
        class="ups-label-card"
        *ngFor="let label of data.labels"
      >
        <div class="ups-label-card__header">
          <h3>
            {{
              "printCardOrders.shipmentPackages.packageTitle"
                | translate : { index: label.index }
            }}
          </h3>
          <span class="ups-label-card__tracking" *ngIf="label.trackingNumber">
            {{ label.trackingNumber }}
          </span>
        </div>

        <p class="ups-label-card__description" *ngIf="label.packageDescription?.trim()">
          {{ label.packageDescription }}
        </p>

        <img
          class="ups-label-card__image"
          [src]="getLabelDataUrl(label.shippingLabelGifBase64)"
          [alt]="
            'printCardOrders.shippingLabels.labelAlt'
              | translate : { index: label.index }
          "
        />

        <div class="ups-label-card__actions">
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="printLabel(label)"
            [disabled]="printing"
          >
            <mat-icon aria-hidden="true">print</mat-icon>
            {{ "printCardOrders.shippingLabels.printLabel" | translate }}
          </button>
        </div>
      </article>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">
      {{ "close" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      *ngIf="data.labels.length > 1"
      (click)="printAll()"
      [disabled]="printing"
    >
      {{ "printCardOrders.shippingLabels.printAll" | translate }}
    </button>
  </footer>
</div>
